exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backdrop{align-items:center;background-size:cover;display:flex;flex-direction:row;justify-content:flex-end;min-height:calc(100vh - 60px)}.backdrop__container{padding-bottom:20px;padding-top:20px}.backdrop__paper{background:rgba(255,255,255,0.96);padding:30px 10px}@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .backdrop__paper{background:rgba(0,0,0,0.96)}}:root[data-theme=dark] .backdrop__paper{background:rgba(0,0,0,0.96)}@media (max-width: 639px){.backdrop{background-image:none !important;min-height:0}.backdrop__container{padding:0}.backdrop__paper{border-radius:0;box-shadow:none}}\n", ""]);

// exports
exports.locals = {
	"backdrop": "backdrop",
	"backdrop__container": "backdrop__container",
	"backdrop__paper": "backdrop__paper"
};